import axios from './axios'

export async function getConfig(){
  return await axios.get('configuracao?acao=configuracao', {})
}